


























































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { UserApi, DepartmentApi, RoleApi, LoginApi } from '@/http';
import { MessageBox, Message } from 'element-ui';
@Component({
    components: {},
})
export default class UserDialog extends Vue {
    public $refs: {
        form: HTMLFormElement;
        tree: HTMLFormElement;
        selectTree: HTMLFormElement;
    };
    // 验证规则
    public formRules = formRules;
    public dialogVisible: boolean = false;
    public form = {
        // id: '',
        userName: '',
        realName: '',
        phoneNumber: '',
        email: '',
        password: '',
        repeatPassword: '',
        enabled: true,
        webMenus: '',
        roleId: '',
        roleName: '',
        primaryDeptId: '',
        departmentId: '',
        departmentName: '',
        currentDepartName: '', //该字段用作弹框中部门名称展示
    };
    public dailyReportTypeList = [];
    public status: number = 1;
    public loading: boolean = false;
    public departmentList = [];
    public roleList = [];

    @Prop({ default: '' })
    title;

    mounted() {}

    //获取部门信息
    public async loadDepartList() {
        await DepartmentApi.GetDepartmentList('').then((res) => {
            this.departmentList = res;
        });
    }
    //部门关键字查询
    typeFilter(value) {
        this.$refs.tree.filter(value);
    }
    filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }
    //节点点击事件
    public departmentName = '';
    handleClickNode(data, e) {
        this.departmentName = '';
        this.breadList.length = 0;
        let field = this.$refs['form'].fields;
        field.map((i) => {
            if (i.prop === 'departmentId') {
                //通过prop属性值相同来判断是哪个输入框
                i.resetField();
                return false;
            }
        });
        this.form.departmentId = data.id;
        this.form.departmentName = data.name ? data.name : data.userName;
        this.form.currentDepartName = data.name ? data.name : data.userName;
        let selectNode = this.$refs.tree.getNode(e); //  获取点击当节点的dom的信息
        this.getparentsNode(selectNode); //调用递归函数
        this.departmentName = this.breadList.join('-');
        //获取当前节点的顶级id
        this.form.primaryDeptId = this.idList[0];
        // console.log('this.primaryDeptId=====>', this.form.primaryDeptId);
        // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
        this.$refs.selectTree.blur();
    }
    // 递归
    public breadList = [];
    public idList = [];
    getparentsNode(node) {
        if (!node.parent) {
            return;
        }
        this.breadList.unshift(node.label);
        this.idList.unshift(node.data.id);
        this.getparentsNode(node.parent); //调用递归
    }
    public defaultProps = {
        label: (data, node) => {
            return data.name ? data.name : data.userName;
        },
        children: 'childrenList',
    };
    //获取角色列表
    public async loadRolesList() {
        await RoleApi.GetRolesList().then((res) => {
            this.roleList = res.data;
            // console.log('this.roleList=====>', JSON.stringify(this.roleList));
        });
    }
    //获取角色权限
    public roleChange(value) {
        // console.log('value===>', value);
        //获取对应id
        this.roleList.forEach((e) => {
            if (e.name == value) {
                this.form.roleId = e.id;
                this.form.roleName = e.name;
            }
        });
        if (this.form.roleId) {
            //获取已选中权限
            RoleApi.GetRoleDetail(this.form.roleId)
                .then((res) => {
                    this.form.webMenus = res.menuPermissions;
                    // console.log('this.form.webMenus====>', this.form.webMenus);
                })
                .catch((err) => {});
        }
    }

    //打开新增弹框
    public addOpen() {
        this.reset();
        this.loadDepartList();
        this.loadRolesList();
        this.dialogVisible = true;
    }
    //打开编辑弹框
    public uid = '';
    public editOpen(id) {
        this.uid = id;
        // this.reset();
        this.loadDepartList();
        this.loadRolesList();
        this.dialogVisible = true;
        this.loading = true;
        UserApi.GetUserDetail(id)
            .then((res) => {
                res.password = '';
                this.form = res;
                let departName = res.departmentName.split('-');
                this.form.departmentName = departName[departName.length - 1];
                this.form.currentDepartName = departName[departName.length - 1];
                // console.log('this.form', JSON.stringify(this.form));
                // this.roleChange(res.roleName);
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
            });
    }

    public addDictForm() {
        if (this.form.password || this.form.repeatPassword) {
            if (this.form.password != this.form.repeatPassword) {
                MessageBox.alert('密码与重复密码不一致，请核实', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                }).then(() => {});
                return;
            }
        }
        this.loading = true;
        this.$refs.form.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增用户') {
                    this.form.departmentName = this.departmentName;
                    UserApi.AddUser({ ...this.form })
                        .then((res) => {
                            this.loading = false;
                            this.$message.success('新增成功!');
                            this.dialogVisible = false;
                            this.$emit('reload');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                } else {
                    if (this.departmentName) {
                        this.form.departmentName = this.departmentName;
                    }
                    UserApi.UpdateUser(this.uid, { ...this.form })
                        .then((res) => {
                            this.loading = false;
                            this.$message.success('编辑成功!');
                            this.dialogVisible = false;
                            this.$emit('reload');
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
            } else {
                this.loading = false;
            }
        });
    }
    public formClose() {
        this.reset();
        this.dailyReportTypeList = [];
        this.dialogVisible = false;
    }
    public reset() {
        this.form = {
            // id: '',
            userName: '',
            realName: '',
            phoneNumber: '',
            email: '',
            password: '',
            repeatPassword: '',
            enabled: true,
            roleId: '',
            roleName: '',
            primaryDeptId: '',
            departmentId: '',
            departmentName: '',
            webMenus: '',
            currentDepartName: '',
        };
    }
    // public selectReset: boolean = true;
    // public async updateReset() {
    //     this.$refs.form.validate((valid) => {});
    //     this.selectReset = true;
    // }
}
